import { render } from "./PinMarker.vue?vue&type=template&id=d238f9c2"
import script from "./PinMarker.vue?vue&type=script&lang=ts"
export * from "./PinMarker.vue?vue&type=script&lang=ts"
script.render = render

export default script